module.exports = [
  require('./bellNumbers'),
  require('./composition'),
  require('./stirlingS2'),
  require('./catalan')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/combinatorics/index.js
// module id = 1327
// module chunks = 0